import { IconButton, Menu, MenuItem } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import NiceModal from "@ebay/nice-modal-react";
import SettingsIcon from "@mui/icons-material/Settings";
import { useCallback, useState } from "react";

const SlideConfigItems = ({ configurationLinks, handleClose }) => {
  const links = configurationLinks.map((link) => {
    return {
      ...link,
      updateModal: useCustomModel(link.modelName).updateModal,
    };
  });

  const handleLinkClick = (link) => {
    if (link.updateModal) {
      NiceModal.show(link.updateModal, {
        id: link.id,
      });
    }
    handleClose();
  };

  return links.map((link) => (
    <MenuItem
      onClick={() => handleLinkClick(link)}
      disabled={!link.id || !link.updateModal}
    >
      {link.label}
    </MenuItem>
  ));
};

const SlideConfigButton = ({ configurationLinks }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const ready = configurationLinks && configurationLinks.length > 0;

  return (
    <>
      <IconButton
        sx={{ position: "absolute", right: "8px", top: "8px" }}
        size="small"
        onClick={handleClick}
        disabled={!ready}
      >
        <SettingsIcon size="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {configurationLinks && (
          <SlideConfigItems
            handleClose={handleClose}
            configurationLinks={configurationLinks}
          />
        )}
      </Menu>
    </>
  );
};

export default SlideConfigButton;
